import { render, staticRenderFns } from "./financialConfig.vue?vue&type=template&id=28fa1ba7&scoped=true"
import script from "./financialConfig.vue?vue&type=script&lang=js"
export * from "./financialConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa1ba7",
  null
  
)

export default component.exports